/* eslint-disable */

import _ from "lodash";

export const sortDisplayOrder = (arr, key) => {
	try {
		arr.sort((a, b) => {
			return a[key] - b[key];
		});
		return arr;
	} catch (err) {
		console.log(err);
		return arr;
	}
};
export const redirectToErrorPage = () => (window.location.href = "/404.html");

export const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result;
};

export const cutString = (str, length) => {
	if (str.length > length) {
		return `${str.substr(0, length)}...`;
	} else {
		return str;
	}
};
//Find common and diffrent key in two jsons
//First agrgument have you want same or diff data
//Second argument will have array of two json
//Third argument will have array of keys which not to be considered in comparision
export const diffAndCommon = (type, objs, ignored) => {
	const diffObject = {};
	Object.keys(objs[0]).map(key => {
		if (ignored.includes(key)) return null;
		const returnType =
			type === "same" ? objs[0][key] === objs[1][key] : objs[0][key] !== objs[1][key];
		if (returnType) {
			diffObject[key] = objs[0][key];
		}
	});

	return diffObject;
};


//Same as diff AndCommon Function, but also checks if array values contains new values or not
export const diffAndCommonTicket = (type, objs, ignored) => {
	const diffObject = {};
	Object.keys(objs[0]).map(key => {
		if (ignored.includes(key)) return null;
		let returnType = false;
		if (type === "same") {
			returnType = objs[0][key] === objs[1][key];
		} else {
			if (Array.isArray(objs[0][key])) {
				const ifFormsChanged = checkArrDuplicate(objs[0][key], objs[1][key]);
				if (ifFormsChanged) {
					returnType = true;
				} else {
					returnType = false;
				}
			} else {
				returnType = objs[0][key] !== objs[1][key];
			}
		}
		if (returnType) {
			diffObject[key] = objs[0][key];
		}
	});

	return diffObject;
};

// Checks if array values contains new values, if there is it returns true and if no new values returns it false
const checkArrDuplicate = (array1, array2) => {
	let newArr = array1.filter(val => !array2.includes(val));
	if (newArr.length === 0) {
		newArr = array2.filter(val => !array1.includes(val));
	}
	if (newArr.length > 0) {
		return true;
	} else {
		return false;
	}
};

//diffAndCommon('same', [data, originalData], []);
export const findCommonElements = (arr1, arr2) => arr1.some(item => arr2.includes(item));

//JavaScript new Date Ordinal (st, nd, rd, th)
export const nth = date => {
	if (date > 3 && date < 21) return "th";
	switch (date % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
};

export const removeDuplicateArrayElements = (obj1, obj2, key) => {
	const arr1 = obj1[key];
	const arr2 = obj2[key];
	let newArray = [];
	newArray = arr1.filter(val => !array2.includes(val));
	return newArray;
};

export const deBouncingFunction = function (func, delay, cancel = false) {
	let timer;
	return function (...args) {
		const context = this;
		clearInterval(timer);
		if (cancel) return;
		timer = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
};

export function replaceEmptyStringsWithNull(obj) {
	for (const key in obj) {
		if (typeof obj[key] === "object" && obj[key] !== null) {
			// Recursively call if the object is not null
			if (Object.keys(obj[key]).length === 0) {
				// If the object is empty, delete it
				// delete obj[key];
				if (key === "Sequence Number") {
					delete obj[key];
				}
			} else {
				replaceEmptyStringsWithNull(obj[key]);
			}
		} else if (obj[key] === "") {
			// Replace empty strings with null
			obj[key] = null;
		}
	}
}

export const imagesModuleNo = {
	event_poster: 1,
	user_profile: 2,
	featured_events: 3,
	resources: 4,
	past_events: 5,
	codeops: 6,
	community: 7,
	speakers: 8,
	sponsors: 9,
	workshops: 10,
	checkin_app: 11,
	branding_images: 12,
	partners: 13,
	exhibitors: 14
}

//prevent background scroll when a modal is open
export const toggleBodyScroll = (isOpen) => {
	if (isOpen) {
		document.body.style.overflow = 'hidden'; // Disable scroll
	} else {
		document.body.style.overflow = 'unset'; // Enable scroll
	}
};

export const regexToValidate = {
	nameRegex: /^[a-zA-Z0-9-:()[\]|,#/<>.&@+! ]+$/,
	urlRegExp: /^[a-zA-Z0-9-]+$/,
	emojiRegex: /[^\u0000-\u007F]+/
}

export const APIStatusCode = {
	STATUS_CODE_SUCCESS: 200,
	STATUS_CODE_CREATED: 201,
	STATUS_CODE_DELETED: 204,
	STATUS_CODE_BAD_REQUEST: 400
}

export const uploadFileSizes = {
	tenMB: 10 * 1024 * 1024, //10 MB
	twentyMB: 20 * 1024 * 1024  // 20 MB 
}

export const isBetaTagRequired = (name) => {
	const betaItems = ["Gallery Page"]; // List of items requiring the Beta tag
	return betaItems.includes(name);
};
